import React, { useEffect, useState } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { selectAuthMenuType, selectUser } from '@/store/selectors/authSelectors';
import { UserType } from '@/store/enums';
import { getRoutes } from './routeBuilder';
import { getProfile } from '@/store/slices/authSlice';
import { fetchClientConfigurations } from '@/store/slices/apiConfigSlice';
import { FULFILLED_ACTION } from '@/config/variables';

const navigationSelector = createSelector(selectUser, selectAuthMenuType, (user, menuType) => ({
  user,
  menuType,
}));

const Routes = (): React.ReactElement => {
  const dispatch = useAppDispatch();
  const [hasfetchedProfile, setHasfetchedProfile] = useState<boolean>(false);
  /*Based on "changeMenuType" -> authSlice.ts
    we should use "menuType" instead of userType. 
    because, one user can switch between SP and SU.   
  */
  useEffect(() => {
    dispatch(getProfile()).then(response => {
      if (response.meta.requestStatus === FULFILLED_ACTION && response.payload) {
        dispatch(fetchClientConfigurations());
        setHasfetchedProfile(true);
        return;
      }
      setHasfetchedProfile(true);
    });
  }, []);

  const { menuType } = useAppSelector(navigationSelector);
  return <>{getRoutes(menuType || UserType.unauthorized, hasfetchedProfile)}</>;
};

export { Routes };
